<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('tennants.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete
                name="org"
                v-model="search_params.organisation_id"
                :items="organisations"
                item-text="name"
                item-value="id"
                :label="$t('organisations.title_s')"
                autocomplete="new-password"
                @change="filter"
                clearable
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                name="tenant-status"
                v-model="search_params.status"
                :items="$dd_tennant_status()"
                item-text="text"
                item-value="key"
                :label="$t('tennants.status')"
                autocomplete="new-password"
                @change="filter"
                clearable
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                name="tenant-type"
                v-model="search_params.type"
                :items="$dd_tenant_types()"
                item-text="text"
                item-value="key"
                :label="$t('tennants.type')"
                autocomplete="new-password"
                @change="filter"
                clearable
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/tennants/create'" v-if="$can('tennant-create')">
        <action-button type="new" />
      </router-link>

      <action-button type="reset" @click="refresh_list" :text="$t('global.refresh')" />

      <action-button
        type="default"
        :text="$t('tennants.run_migration')"
        icon="fas fa-database"
        @click="migrate"
        :disabled="selected.length == 0"
      />
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="tennants"
            :items-per-page="tennants.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            v-model="selected"
            :single-select="false"
            :show-select="true"
            :must-sort="true"
          >
            <template v-slot:item.organisation_id="{ item }">
              {{ item.organisation.name }}
            </template>

            <template v-slot:item.active_from="{ item }">
              {{ moment.utc(item.active_from).format(DATE_FORMAT) }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_tennant_status(item.status) }}
            </template>

            <template v-slot:item.type="{ item }">
              {{ $dd_tenant_types(item.type) }}
            </template>
            
            <template v-slot:item.connection_name="{ item }">
              {{ $dd_tenant_connection_names(item.connection_name) }}
            </template>

            <template v-slot:item.last_migrated_at="{ item }">
              {{ item.last_migrated_at ? moment(item.last_migrated_at).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{
                  path: BACKEND_URL + '/tennants/edit/' + item.id,
                  props: { id: item.id }
                }"
                v-if="$can('tennant-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <!-- <action-button
                                type="delete"
                                @click="del(item.id)"
                                v-if="$can('tennant-delete')"
                                :icon_only="true"
                                small
                            /> -->

              <!--<action-button v-if="item.is_setup !== 1" type="default" @click="setup(item.id)" :text="$t('tennants.setup')" color="info" icon="fas fa-tools" :icon_only="true" small />
                            <action-button v-if="item.is_setup === 1" type="default" @click="migrate(item.id)" :text="$t('tennants.run_migration_short')" color="info" icon="fas fa-database" :icon_only="true" small />-->
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showDialogForm" persistent max-width="480px">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "tennantList",

  components: {
    "deletemodal-form": () => import("../components/DeleteModal")
  },

  data() {
    return {
      url: "",
      tennants: [],
      organisations: [],
      selected: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_Tenant_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["subdomain"],
        sortDesc: [false]
      },
      search_params: {
        any: ""
      },

      showDialogForm: false,
      currentFormId: "",
      currentForm: ""
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_Tenant_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Tenant_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("organisations.title"), value: "organisation_id" },
          { text: this.$t("tennants.subdomain"), value: "subdomain" },
          { text: this.$t("tennants.email"), value: "email" },
          { text: this.$t("tennants.status"), value: "status" },
          { text: this.$t("tennants.type"), value: "type" },
          { text: this.$t("tennants.active_from"), value: "active_from" },
          { text: this.$t("tennants.connection_name"), value: "connection_name" },
          {
            text: this.$t("tennants.payed_for_users"),
            value: "payed_for_users"
          },
          {
            text: this.$t("tennants.last_migrated_at"),
            value: "last_migrated_at"
          },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    },
    currentLoadedForm: function() {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "tennants"
  },

  created() {
    // Get Organisations
    axios.get(this.API_URL + "organisations?show_all=true").then((res) => {
      this.organisations = res.data.data
    })
  },

  methods: {
    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Tenant_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Tenant_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      this.tennants = []

      axios.get(this.url + "?" + query).then((res) => {
        this.tennants = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem("__filter_Tenant_List", JSON.stringify(this.search_params))
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    refresh_list() {
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          vm.showForm(id, "deletemodal")
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    migrate() {
      let vm = this

      this.$awn.confirm(
        this.$t("tennants.tenant_migration_warning"),
        () => {
          axios
            .put(this.API_URL + "tennants/migration", {
              ids: this.selected.map((a) => a.id).join(",")
            })
            .then((res) => {
              if (res.data.status) {
                vm.$awn.success(vm.$t("tennants.db_migration_success"))
                vm.refresh_list()
              } else {
                vm.$awn.alert(res.data.message)
              }
            })
        },
        () => {
          return
        },
        {
          labels: {
            confirmOk: vm.$t("global.yes"),
            confirmCancel: vm.$t("global.no")
          }
        }
      )
    },

    setup(id) {
      let vm = this

      axios
        .put(this.API_URL + "tennant/setup/" + id)
        .then((res) => {
          vm.$awn.success(vm.$t("global.tenant_setup_success"))
          vm.refresh_list()
        })
        .catch((err) => console.log(err))
    },

    showForm(id, type) {
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form() {
      this.return_modal_cancel_form()
      this.refresh_list()
    },
    return_modal_cancel_form() {
      this.currentFormId = ""
      this.currentForm = ""
      this.showDialogForm = false
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
